import { AdminBalancesClient } from './admin-balances-client';

export const metadata = { title: 'Balances · Admin' };

export default function Page() {
  return <AdminBalancesClient />;
}
